import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'

export const REQUEST_EVENT = createAction('REQUEST_EVENT')
export const RECEIVE_EVENT = createAction('RECEIVE_EVENT')
export const CREATE_EVENT = createAction('CREATE_EVENT')
export const EDIT_EVENT = createAction('EDIT_EVENT')
export const DELETE_EVENT = createAction('DELETE_EVENT')
export const DELETE_EVENT_STAGE = createAction('DELETE_EVENT_STAGE')

export const fetchEvent = (id) => {
  return (dispatch) => {
    dispatch(REQUEST_EVENT())

    return Api.viewEvent(id)
      .then(response => dispatch(RECEIVE_EVENT({data: response.data})))
      .catch(error => {
        dispatch(RECEIVE_EVENT(error.response))
        dispatch(setAlert(error.response.data.message, undefined, 'error'))
      })
  }
}

export const createEvent = (event) => {
  return (dispatch) => {
    return dispatch(CREATE_EVENT(Api.createEvent(event)))
  }
}


export const editEvent = (eventId, data) => {
  return (dispatch) => {
    return dispatch(EDIT_EVENT(Api.editEvent(eventId, data)))
  }
}

export const deleteEvent = (eventId) => {
  return (dispatch) => {
    return dispatch(DELETE_EVENT(Api.deleteEvent(eventId)))
  }
}

export const deleteEventStage = (stageId) => {
  return (dispatch) => {
    return dispatch(DELETE_EVENT_STAGE(Api.deleteEventStage(stageId)))
  }
}



// WEBPACK FOOTER //
// ./src/actions/event.js